import SortModel from './sort/index.model.js';
import FacetTypeModel from './type/index.model.js';
const model = {
    name: 'Facet',
    properties: {
        all: {},
        max: {},
        sort: { type: 'model', model: SortModel },
        types: { type: 'array', model: FacetTypeModel },
    },
};
export default model;
